import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Card, Row, Col } from 'react-bootstrap'
import './mercadopago.css' // Importe o arquivo de estilos
import Navbar from '../../components/navbar/navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faUndo, faBan } from '@fortawesome/free-solid-svg-icons'
import getPaymentMethodIcon from '../../style/icons' // Verifique o caminho correto
import apinode from '../../services/apinode'
import ReactPaginate from 'react-paginate'

const FinanceScreen = () => {
  const [financialData, setFinancialData] = useState([])
  const [storeOptions, setStoreOptions] = useState([])
  const [selectedStore, setSelectedStore] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')
  const [endDate, setEndDate] = useState('')
  const [startDate, setStartDate] = useState('')
  const [filterByApprovalDate, setFilterByApprovalDate] = useState(false)
  const [filterByReceiptDate, setFilterByReceiptDate] = useState(false)
  let filtro = ''
  const [currentPage, setCurrentPage] = useState(0)

  // Função para lidar com a mudança de página
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected)
  }

  // Número de itens por página
  const itemsPerPage = 10 // Defina o número desejado de itens por página

  // Calcule os itens a serem exibidos na página atual
  const startIndex = currentPage * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentItems = financialData.slice(startIndex, endIndex)

  const handleFilterButtonClick = () => {
    if (selectedStore) {
      const queryParams = new URLSearchParams()
      queryParams.append('contaml', selectedStore)
      queryParams.append('conta', localStorage.idconta)

      if (filterByApprovalDate) {
        queryParams.append('approvalDate', 'true')
        filtro = 'approval'
      } else if (filterByReceiptDate) {
        queryParams.append('receiptDate', 'true')
        filtro = 'receipt'
      }

      if (startDate) {
        queryParams.append('startDate', startDate.toISOString())
      }
      if (endDate) {
        queryParams.append('endDate', endDate.toISOString())
      }

      const queryString = queryParams.toString()

      fetchFinancialData(selectedStore, startDate, endDate, filtro)
    }
  }

  const handleFilterByApprovalDateChange = () => {
    if (!filterByApprovalDate) {
      setFilterByApprovalDate(true)
      setFilterByReceiptDate(false)
    }
  }

  const handleFilterByReceiptDateChange = () => {
    if (!filterByReceiptDate) {
      setFilterByReceiptDate(true)
      setFilterByApprovalDate(false)
    }
  }

  useEffect(() => {
    fetchStoreOptions()
  }, [])

  useEffect(() => {
    const now = new Date()
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
    setStartDate(firstDayOfMonth)
    setEndDate(now)
    console.log(firstDayOfMonth)

    // if (selectedStore) {
    //     fetchFinancialData(selectedStore);
    // }
  }, [])

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value)
  }

  const paymentMethods = [
    ...new Set(financialData.map((item) => item.PAYMENT_METHOD_ID)),
  ]

  // function getPaymentMethodIconElement(method, className) {
  //     const icon = faIconForMethod(method); // Substitua pela função que retorna o ícone correto para o método
  //     return <FontAwesomeIcon icon={icon} className={className} />;
  // }

  const calculateTotalAmountByMethod = (method) => {
    return financialData.reduce((total, item) => {
      if (item.PAYMENT_METHOD_ID === method) {
        return total + item.TRANSACTION_AMOUNT
      }
      return total
    }, 0)
  }

  const filterFinancialDataByMonth = (data, month) => {
    if (!month) {
      return data
    }
    return data.filter(
      (item) => new Date(item.DATE_APPROVED).getMonth() === parseInt(month) - 1,
    )
  }

  const filteredData = filterFinancialDataByMonth(financialData, selectedMonth)
  console.log(filteredData)

  const calculateTotalAmount = (status) => {
    return financialData.reduce((total, item) => {
      if (item.STATUS === status) {
        return total + item.TRANSACTION_AMOUNT
      }
      return total
    }, 0)
  }

  function formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  function handleStartDateChange(event) {
    const inputValue = event.target.value // Assuming inputValue is in a valid date format
    const selectedDate = new Date(inputValue)
    if (!isNaN(selectedDate)) {
      // Check if the date is valid
      setStartDate(selectedDate)
    } else {
      console.log('Invalid date:', inputValue)
    }
  }

  function handleEndDateChange(event) {
    const inputValue = event.target.value // Assuming inputValue is in a valid date format
    const selectedDate = new Date(inputValue)
    if (!isNaN(selectedDate)) {
      // Check if the date is valid
      setEndDate(selectedDate)
    } else {
      console.log('Invalid date:', inputValue)
    }
  }

  const fetchStoreOptions = async () => {
    try {
      console.log('Fetching store options...')
      const response = await apinode.get(`/api/lojas/${localStorage.idconta}`)
      console.log('Store options response:', response.data)
      setStoreOptions(response.data)
      if (response.data.length > 0) {
        setSelectedStore(response.data[0].ID_CONTA) // Seleciona o ID da primeira opção por padrão
      }
    } catch (error) {
      console.error('Erro ao buscar opções de lojas:', error)
    }
  }

  const fetchFinancialData = async (
    storeId,
    startDate,
    endDate,
    filterType,
  ) => {
    try {
      console.log('Fetching financial data for store ID:', storeId)
      const response = await apinode.get(
        `/api/mercadopago/${storeId}/${localStorage.idconta}`,
        {
          params: {
            startDate: startDate,
            endDate: endDate,
            filterType: filterType,
          },
        },
      )
      setFinancialData(response.data)
      console.log(response.data)
    } catch (error) {
      console.error('Erro ao buscar dados financeiros:', error)
    }
  }

  const handleStoreChange = (event) => {
    setSelectedStore(event.target.value)
  }

  return (
    <div className="finance-screen">
      <Navbar />
      <div className="container-fluid mt-page">
        <div className="finance-table-container">
          <h2 className="text-center">Dados Financeiros do Mercado Pago</h2>
          <Row>
            <Col lg={4}>
              <Card className="filter-card">
                <Card.Body>
                  <Card.Title>Filtros de Pesquisa</Card.Title>
                  <div className="mb-3">
                    <label
                      htmlFor="storeDropdown"
                      className="form-label"
                    >
                      Selecionar conta:
                    </label>
                    <select
                      id="storeDropdown"
                      className="form-select"
                      value={selectedStore}
                      onChange={handleStoreChange}
                    >
                      {storeOptions.map((option) => (
                        <option
                          key={option.ID_CONTA}
                          value={option.ID_CONTA}
                        >
                          {option.APELIDO}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="date-filters">
                    <div className="mb-3">
                      <label
                        htmlFor="startDatePicker"
                        className="form-label"
                      >
                        Data inicial:
                      </label>
                      <input
                        type="date"
                        id="startDatePicker"
                        className="form-control"
                        value={
                          startDate ? startDate.toISOString().split('T')[0] : ''
                        }
                        onChange={handleStartDateChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="endDatePicker"
                        className="form-label"
                      >
                        Data final:
                      </label>
                      <input
                        type="date"
                        id="endDatePicker"
                        className="form-control"
                        value={
                          endDate ? endDate.toISOString().split('T')[0] : ''
                        }
                        onChange={handleEndDateChange}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-check-label">Filtrar por:</label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        id="approvalDateCheckbox"
                        className="form-check-input"
                        checked={filterByApprovalDate}
                        onChange={() => {
                          handleFilterByApprovalDateChange(
                            !filterByApprovalDate,
                          )
                          handleFilterByReceiptDateChange(false)
                        }}
                      />
                      <label
                        htmlFor="approvalDateCheckbox"
                        className="form-check-label"
                      >
                        Data de Aprovação
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        id="receiptDateCheckbox"
                        className="form-check-input"
                        checked={filterByReceiptDate}
                        onChange={() => {
                          handleFilterByReceiptDateChange(!filterByReceiptDate)
                          handleFilterByApprovalDateChange(false)
                        }}
                      />
                      <label
                        htmlFor="receiptDateCheckbox"
                        className="form-check-label"
                      >
                        Data de Recebimento
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handleFilterButtonClick}
                    className="btn btn-primary"
                  >
                    Filtrar
                  </button>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={8}>
              <div className="d-flex justify-content-around mb-4">
                <Card className="finance-card">
                  <Card.Body>
                    <Card.Title>Total Aprovado</Card.Title>
                    <Card.Text>
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="icon-success"
                      />
                      {calculateTotalAmount('approved').toLocaleString(
                        'pt-BR',
                        { style: 'currency', currency: 'BRL' },
                      )}
                    </Card.Text>
                  </Card.Body>
                </Card>
                <Card className="finance-card">
                  <Card.Body>
                    <Card.Title>Total Estornado</Card.Title>
                    <Card.Text>
                      <FontAwesomeIcon
                        icon={faUndo}
                        className="icon-warning"
                      />
                      {calculateTotalAmount('refunded').toLocaleString(
                        'pt-BR',
                        { style: 'currency', currency: 'BRL' },
                      )}
                    </Card.Text>
                  </Card.Body>
                </Card>
                <Card className="finance-card">
                  <Card.Body>
                    <Card.Title>Total Rejeitado</Card.Title>
                    <Card.Text>
                      <FontAwesomeIcon
                        icon={faBan}
                        className="icon-danger"
                      />
                      {calculateTotalAmount('rejected').toLocaleString(
                        'pt-BR',
                        { style: 'currency', currency: 'BRL' },
                      )}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
              <Row>
                {paymentMethods.map((method, index) => (
                  <Col
                    key={index}
                    md={4}
                    className="mb-4"
                  >
                    <Card className="payment-method-card">
                      <Card.Body>
                        <Card.Title>{method}</Card.Title>
                        <Card.Text>
                          {getPaymentMethodIcon(method)}
                          {calculateTotalAmountByMethod(method).toLocaleString(
                            'pt-BR',
                            {
                              style: 'currency',
                              currency: 'BRL',
                            },
                          )}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* Restante da tabela e dos dados financeiros */}
            </Col>
          </Row>

          <Card p3>
            <Table
              striped
              bordered
              hover
              responsive
              className="nowrap"
              style={{
                fontSize: '14px',
                lineHeight: '1.5',
                padding: '20px' /* outros estilos */,
              }}
            >
              <thead>
                <tr>
                  <th className="text-dark">ID Pgto</th>
                  <th className="text-dark">Item</th>
                  <th className="text-dark">N. Pedido ML</th>
                  <th className="text-dark">Metedo de Pgto</th>
                  <th className="text-dark">Valor da Transação</th>
                  <th className="text-dark">Status</th>
                  <th className="text-dark">Data aprovação</th>
                  <th className="text-dark">Data recebimento</th>
                  <th className="text-dark">Valor total pago</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr
                    key={index}
                    className={item.STATUS === 'approved' ? '' : 'table-danger'}
                  >
                    <td>{item.ID}</td>
                    <td>{item.REASON}</td>
                    <td>{item.ORDER_ID}</td>
                    <td>{item.PAYMENT_METHOD_ID}</td>
                    <td>
                      {item.TRANSACTION_AMOUNT.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                    <td>{item.STATUS}</td>
                    <td>{new Date(item.DATE_APPROVED).toLocaleString()}</td>
                    <td>{new Date(item.DATE_REFUNDED).toLocaleString()}</td>
                    <td>
                      {item.TOTAL_PAID_AMOUNT.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <ReactPaginate
              previousLabel={'Anterior'}
              nextLabel={'Próxima'}
              breakLabel={'...'}
              pageCount={Math.ceil(financialData.length / itemsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={'pagination'}
              activeClassName={'active'}
            />
          </Card>
        </div>
      </div>
    </div>
  )
}

export default FinanceScreen
